import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DisplayableOperation } from '../../../../types/types';

const list: DisplayableOperation[]  = [];

const initialState = list;

const operationHistoryList = createSlice({
  name: 'operation-history-List',
  initialState,
  reducers: {
    setOperationHistoryList: (state,action:PayloadAction<DisplayableOperation[]>) => {

      return (state = action.payload)
      
    },
  },
 
});

// Reducer
export default operationHistoryList.reducer;

// Actions
export const {setOperationHistoryList} = operationHistoryList.actions;